<div class="not-found">

  <img class="not-found-image mat-elevation-z10"
       src="https://d8avu785lzlph.cloudfront.net/images/http-error-404-not-found.png">

  <h1>Page Not Found</h1>
  <p>Did you mistype something in the browser address bar?</p>

  <a routerLink="/courses">To Courses Page</a>

</div>


<page-footer></page-footer>
